import { collection, addDoc, doc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import { db } from "@/firebase";

export function crearProductoDeposito({
  citaId = "",
  paciente = {},
  monto = 0,
  descripcion,
} = {}) {
  const montoNormalizado = Math.max(0, Number(monto) || 0);
  const pacienteNombre = `${paciente.nombre || ""} ${paciente.apellido || ""}`
    .trim()
    .replace(/\s+/g, " ")
    .trim();
  const referenciaPaciente = paciente.uid || paciente.id || "";
  const nombrePaciente = pacienteNombre ? ` · ${pacienteNombre}` : "";

  const nombreBase =
    descripcion ||
    (citaId
      ? `Depósito presencial cita ${citaId}`
      : `Depósito presencial${nombrePaciente}`);

  const idBase =
    citaId ||
    (referenciaPaciente ? referenciaPaciente : `manual-${Date.now().toString(36)}`);

  return {
    id: `deposito-${idBase}`,
    nombre: nombreBase,
    precio: montoNormalizado,
    cantidad: 1,
    tipo: "servicio",
    pacienteId: referenciaPaciente || null,
    pacienteNombre,
    citaId: citaId || null,
  };
}

export async function registrarDepositoEnVentas({
  producto,
  monto,
  metodo = "efectivo",
  citaId = null,
  pacienteId = null,
} = {}) {
  if (!producto) {
    throw new Error("Debe proveer el producto del depósito.");
  }

  const total = Math.max(0, Number(monto) || Number(producto.precio) || 0);
  if (total <= 0) {
    throw new Error("El depósito debe ser mayor a cero.");
  }

  const venta = {
    productos: [
      {
        id: producto.id || "",
        nombre: producto.nombre || "Depósito presencial",
        cantidad: Number(producto.cantidad) || 1,
        precio: Number(producto.precio) || total,
        impuesto: 0,
        tipo: producto.tipo || "servicio",
        totalLinea: Number(total),
      },
    ],
    subtotal: Number(total),
    descuento: 0,
    impuestos: 0,
    total: Number(total),
    metodoPago: metodo,
    metodosDePago: [{ metodo, monto: total }],
    balancePendiente: 0,
    fecha: Timestamp.now(),
    origen: "deposito-presencial",
    pacienteId,
    citaId,
  };

  const ventaRef = await addDoc(collection(db, "ventas"), venta);

  if (citaId) {
    const citaRef = doc(db, "citasGlobales", citaId);
    const citaSnap = await getDoc(citaRef);
    if (citaSnap.exists()) {
      const citaData = citaSnap.data();
      const nuevoBalance = Math.max(
        0,
        (citaData.balancePendiente || 0) - total
      );
      await updateDoc(citaRef, {
        balancePendiente: nuevoBalance,
        pagada: nuevoBalance === 0,
      });
    }
  }

  return { ventaId: ventaRef.id };
}
